
import { Component, Vue } from 'vue-property-decorator'
import { backToBefore } from '@/utils/h5ToApp'
import { GetRoleByCompany, RolesDto } from '@/api/roles'

@Component({})
export default class RoleRules extends Vue {
  refreshing = false

  roleList: Array<RolesDto> = []

  created () {
    this.getRoleByCompany()
  }

  handleBack () {
    backToBefore()
  }

  // 获取公司角色信息
  getRoleByCompany () {
    GetRoleByCompany({}).then(res => {
      this.roleList = res.data
      this.refreshing = false
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.getRoleByCompany()
  }

  goRules (role: RolesDto) {
    if (!this.$action('roleSetting')) {
      return false
    }
    this.$router.push({
      path: '/roles/roleSetting',
      query: {
        ...role
      }
    })
  }
}
